<template>
  <fieldset class="form-group">
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>{{ inputs.type_responsable.name }}</h5>
      </legend>

      <div class="col-md-4">
        <div class="form-group">
          <label>{{ $t("full_name") }}</label>
          <app-input
            type="text"
            v-model="inputs.name"
            placeholder="Ingrese sus nombres y apellidos"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>{{ $t("position") }}</label>
          <app-input
            type="text"
            v-model="inputs.position"
            placeholder="Ingrese su cargo"
            :required="true"
            :disabled="inputs.responsable_id != null || disabled"
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>{{ $t("email") }}</label>
          <app-input
            type="text"
            v-model="inputs.email"
            placeholder="Ingrese su email"
            :required="true"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    inputs: Object,
    disabled: Boolean,
  },
};
</script>
